module.exports = __webpack_public_path__ + "img/client-herdora-cosmeticos.951a8a4c.jpg";